import { initAgencySettings } from 'services/agency-settings';

const loadAgencySettings = async (): Promise<void> => {
  initAgencySettings();
};

export default loadAgencySettings;
